import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_PAYMENT_ORDER;

const STATE_PENDING = 0;
const STATE_AUTHORIZED = 1;
const STATE_PAID = 2;
const STATE_REJECTED = 3;

const STATE_PENDING_NAME = "Pendiente Aprobación";
const STATE_AUTHORIZED_NAME = "Aprobado";
const STATE_PAID_NAME = "Pagado";
const STATE_REJECTED_NAME = "Rechazado";

const BANK_ICBC_CODE = 15;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(params) {
  return wsService.make_post_request(section + "/create", params);
}

function update(params) {
  return wsService.make_post_request(section + "/update", params);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function get(id) {  
  return wsService.make_get_request(section + "/get/" + id);
}

function authorize(params) {
  return wsService.make_post_request(section + "/authorize", params);
}

function list_states() {
  return wsService.make_get_request(section + "/list_states");
}

function export_filter(params) {
  return wsService.make_post_request(section + "/export", params, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/vnd.ms-excel",
    },
  });
}

function export_bank_icbc(params) {
  return wsService.make_post_request(section + "/export-bank-icbc", params, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/vnd.ms-excel",
    },
  });
}

function listPendingSpents(params = {}) {
  return wsService.make_post_request(section + "/pending-spents", params);
}

function create_massive(params) {
  return wsService.make_post_request(section + "/create-massive", params);
}

function revert(params) {
  return wsService.make_post_request(section + "/revert", params);
}

function remove_multiple(param = {}) {
  return wsService.make_delete_request(section + "/delete-multiple", param);
}

export const paymentOrderService = {
    filter,
    create,
    update,
    remove,
    remove_multiple,
    get,
    authorize,
    revert,
    list_states,
    export_filter,
    export_bank_icbc,
    listPendingSpents,
    create_massive,
    STATE_PENDING,
    STATE_AUTHORIZED,
    STATE_PAID,
    STATE_REJECTED,
    STATE_PENDING_NAME,
    STATE_AUTHORIZED_NAME,
    STATE_PAID_NAME,
    STATE_REJECTED_NAME,
    BANK_ICBC_CODE
};
